import React, { useState } from "react";
import { CssBaseline, Container } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { useLocation } from "react-router-dom";
import { isAuthenticated } from "./utils/auth";
import LoginPage from "./pages/LoginPage";
import FancyAppBar, { APP_BAR_HEIGHT } from "./components/FancyAppBar"; // Import from new file

const App: React.FC = () => {
    const location = useLocation();
    const showAppBar = isAuthenticated() && location.pathname !== "/login";
    const isLoginPage = location.pathname === "/login";

    // Mobile-only nav drawer toggle (hamburger in the app bar <-> temporary drawer).
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    return (
        <>
            <CssBaseline />
            {showAppBar && <FancyAppBar onMenuClick={() => setMobileNavOpen((o) => !o)} />}
            {isLoginPage ? (
                <LoginPage />
            ) : (
                <Container
                    maxWidth={false}
                    disableGutters
                    sx={{
                        mt: `${APP_BAR_HEIGHT}px`,
                        mx: "auto",
                        px: { xs: 0, sm: 4 },
                        pb: 4,
                        width: '100%',
                    }}
                >
                    <AppRoutes
                        mobileNavOpen={mobileNavOpen}
                        onMobileNavClose={() => setMobileNavOpen(false)}
                    />
                </Container>
            )}
        </>
    );
};

export default App;
